import { WordPressApi } from "./WordPressApi";

export class Repository {
    api = WordPressApi.getInstance();
}